import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import styles from './navigation-wrapper.css'

const NavigationWrapper = ({ children }) => {
  const sideNav = useSelector(state => state.navigation.sideNav) || false
  return (
    <div className={classnames(styles.navWrapper, {
      [styles.overlay]: sideNav
    })}
    >
      {children}
    </div>
  )
}

NavigationWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]).isRequired
}

export default NavigationWrapper
